import { apiClient } from '@/lib/apiClient';

// Contact API endpoints using the centralized apiClient

export interface ContactSearchResult {
  id: number;
  lead_id?: number;
  first_name: string;
  last_name: string;
  email?: string;
  phone?: string;
}

export interface ContactSearchResponse {
  contacts: ContactSearchResult[];
  total_count: number;
  search_params: {
    name: string;
    lead_id?: number;
  };
}

// New Contact Book interfaces for unified phone/email search
export interface ContactPhone {
  number: string;
  isPrimary: boolean;
}

export interface ContactEmail {
  address: string;
  isPrimary: boolean;
}

export interface ContactBookResult {
  contact_id: number;
  full_name: string;
  designation: string;
  department: string;
  lead_id: number;
  lead_name: string;
  phones: ContactPhone[];
  emails: ContactEmail[];
}

export interface ContactBookResponse {
  contacts: ContactBookResult[];
  total_count: number;
  search_params: {
    name: string | null;
    phone: string | null;
    email: string | null;
  };
}

export const searchContactsByName = async (name: string): Promise<ContactSearchResponse> => {
  try {
    console.log(`🔍 Searching contacts by name: ${name}`);
    const response = await apiClient.get(`/contacts/search/name/${encodeURIComponent(name)}`);
    return response;
  } catch (error) {
    console.error('💥 Error searching contacts by name:', error);
    throw error;
  }
};

export const searchContactsByNameInLead = async (name: string, leadId: number): Promise<ContactSearchResponse> => {
  try {
    console.log(`🔍 Searching contacts by name: ${name} in lead: ${leadId}`);
    const response = await apiClient.get(`/contacts/search/name/${encodeURIComponent(name)}/lead/${leadId}`);
    return response;
  } catch (error) {
    console.error('💥 Error searching contacts by name in lead:', error);
    throw error;
  }
};

// New unified contact book search
export const searchContactBook = async (query: string, type: 'phone' | 'email'): Promise<ContactBookResponse> => {
  try {
    console.log(`📞 Searching contact book by ${type}: ${query}`);
    const encodedQuery = encodeURIComponent(query);
    const response = await apiClient.get(`/contacts/book/${type}/${encodedQuery}`);
    return response;
  } catch (error) {
    console.error(`💥 Error searching contact book by ${type}:`, error);
    throw error;
  }
};